/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { accessAPI, readFromLS, Boton } from "../shared";

// Bloquea el uso de la plataforma hasta que el cliente acepte los
// acuerdos de servicio (EULAs) pendientes. Se muestran de a uno y sólo
// desaparecen cuando el usuario los acepta.
export default function EulaGate() {
  const [eulasPendientes, setEulasPendientes] = useState([]);
  const [loaderAceptar, setLoaderAceptar] = useState(false);
  const [leidoYAceptado, setLeidoYAceptado] = useState(false);

  useEffect(() => {
    // Si no hay token todavía no hay sesión, no hay nada que verificar
    if (!readFromLS(process.env.REACT_APP_LS_LOGIN_TOKEN)) {
      return;
    }
    accessAPI(
      "GET",
      "cliente/eula/pendientes",
      null,
      (respuesta) => {
        setEulasPendientes(respuesta);
      },
      () => {}
    );
  }, []);

  function aceptarEula(eulaId) {
    setLoaderAceptar(true);
    accessAPI(
      "POST",
      `cliente/eula/${eulaId}/aceptar`,
      {},
      () => {
        setLoaderAceptar(false);
        setLeidoYAceptado(false);
        setEulasPendientes((pendientes) =>
          pendientes.filter((eula) => eula.id !== eulaId)
        );
      },
      () => {
        setLoaderAceptar(false);
      }
    );
  }

  if (eulasPendientes.length === 0) {
    return null;
  }

  const eula = eulasPendientes[0];

  return (
    <Dialog
      visible
      modal
      closable={false}
      draggable={false}
      header="Hemos actualizado nuestra política de servicio, por favor lea con cuidado y acepte debajo"
      onHide={() => {}}
      className="w-full lg:w-8 md:w-10"
      footer={
        <div
          css={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "1em"
          }}
        >
          <label
            css={{
              display: "flex",
              alignItems: "center",
              gap: "0.5em",
              cursor: "pointer"
            }}
          >
            <Checkbox
              checked={leidoYAceptado}
              onChange={(e) => setLeidoYAceptado(e.checked)}
            />
            Leí y acepto los términos del acuerdo
          </label>
          <Boton
            verde
            disabled={!leidoYAceptado}
            loader={loaderAceptar}
            callback={() => aceptarEula(eula.id)}
          >
            Aceptar
          </Boton>
        </div>
      }
    >
      <div
        css={{
          whiteSpace: "pre-wrap",
          maxHeight: "60vh",
          overflowY: "auto"
        }}
      >
        {eula.texto}
      </div>
    </Dialog>
  );
}
